import { UserRole } from "utils/role";
import { TNoShowDetailInfo } from "./types";
import { cancelNoshow, cancelNoshowRequest, getNoshowDetailInfo } from "apis/meetings/no-show";
import { extractHtmlText } from "utils/validation";

export class NoshowDetailService {
  //* INFO: 노쇼 예약 상세 정보 조회
  async getNoshowDetailInfo(id: string, startDate: Date, endDate: Date): Promise<TNoShowDetailInfo | null> {
    //* startDate 시간 필터를 00분 00초로 설정
    startDate.setHours(0, 0, 0, 0);

    //* endDate 시간 필터를 23시 59분 59초로 설정
    endDate.setHours(23, 59, 59, 999);
    const detailInfo = await getNoshowDetailInfo(id, startDate, endDate);

    if (detailInfo.success && detailInfo.data) return detailInfo.data;
    else return null;
  }

  //* INFO: 노쇼 예약 취소 요청 보내기
  async requestCancelNoshow(instanceId: string): Promise<boolean> {
    const res = await cancelNoshowRequest(instanceId);
    return res.success;
  }

  //* INFO: 노쇼 예약 취소하기
  async cancelNoshow(instanceId: string): Promise<boolean> {
    const res = await cancelNoshow(instanceId);
    return res.success;
  }

  //* INFO: 방문자 정보가 있는지 확인
  getHasVisitors(detailInfo: TNoShowDetailInfo): boolean {
    if (
      detailInfo.reservationCreator?.isVisitor ||
      detailInfo.reservationAttendees.some((attendee) => attendee.isVisitor)
    )
      return true;
    return false;
  }

  //* INFO: 취소 요청 & 취소하기 버튼 활성화 가능한 권한 확인 (SuperAdmin, Owner만 가능), 반복 예약인 경우만 가능
  getIsButtonActive(isRepeatRsv: boolean, role?: UserRole): boolean {
    if ((role === UserRole.SuperAdmin || role === UserRole.Owner) && isRepeatRsv) {
      return true;
    } else return false;
  }

  //* INFO: 메모 가져오기
  getMemo(role?: UserRole, detailInfo?: TNoShowDetailInfo): string {
    if (role && role > UserRole.SuperAdmin && detailInfo?.isPrivate) return "비공개";
    const memo = extractHtmlText(detailInfo?.memo ?? "").text;
    if (!memo || memo === "") return "-";
    else return memo;
  }

  //* INFO: 회의 제목 가져오기
  getTitle(role?: UserRole, detailInfo?: TNoShowDetailInfo): string {
    if (role && role > UserRole.SuperAdmin && detailInfo?.isPrivate) {
      return "비공개 회의";
    } else return detailInfo?.title ?? "";
  }

  //* INFO: 회의 예약자 가져오기
  getCreatorString(role?: UserRole, detailInfo?: TNoShowDetailInfo): string {
    if (role && role > UserRole.SuperAdmin && detailInfo?.isPrivate) {
      return "비공개";
    } else {
      return detailInfo?.reservationCreator?.isVisitor
        ? `${detailInfo.reservationCreator.visitorEmail}*`
        : `${detailInfo?.reservationCreator?.member?.nickname} (${detailInfo?.reservationCreator?.member?.email})`;
    }
  }
}
